import { filterContent, getCMSData } from "./utils";

export const getBanner = async () => {
  const allBanners = await getCMSData()
    .then((response) => response.json())
    .then((data) => data.items.filter(filterContent("banners")));

  return allBanners[0];
};
